import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export function ServiceQueueSpecialist() {
  this.checkPermission = () => new Promise((resolve, reject) => {
    axios.get('queue/permission')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.setGroup = () => new Promise((resolve, reject) => {
    axios.patch('queue/set-group')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.listQueue = () => new Promise((resolve, reject) => {
    axios.get('queue/list')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.updateQueue = payload => new Promise((resolve, reject) => {
    axios.put('queue/update', payload)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
